import React from 'react'
import { SectionPlaceholder } from 'src/components'
import { AboutMeCard } from './components'
import { SimpleGrid, Stack, useMantineTheme } from '@mantine/core'
import { AboutMeContent, MenuLinks } from 'src/content'

export interface AboutMeProps {}

export const AboutMe: React.FC<AboutMeProps> = () => {
  const { AboutMe } = AboutMeContent
  const { colors } = useMantineTheme()
  const { MenuAnchor } = MenuLinks

  return (
    <SectionPlaceholder
      title="About Me"
      fluid
      titleColor={colors.gray[2]}
      customStyles={{ backgroundColor: '#451599' }}
      anchorClassName={MenuAnchor.About}
    >
      <Stack align="apart" mt={'lg'} px={'xl'}>
        <SimpleGrid
          mt={'md'}
          cols={4}
          spacing={50}
          breakpoints={[
            { maxWidth: 'md', cols: 2 },
            { maxWidth: 'sm', cols: 1 },
          ]}
          sx={{ placeItems: 'center', marginInline: 30 }}
        >
          <AboutMeCard {...AboutMe.location} />
          <AboutMeCard {...AboutMe.langauges} />
          <AboutMeCard {...AboutMe.degree} />
          <AboutMeCard {...AboutMe.work} />
        </SimpleGrid>
      </Stack>
    </SectionPlaceholder>
  )
}
